// The chat last open, per staff member and company (see chatDrafts' draftScope), so coming
// back to Chat from elsewhere in Care Diary opens it again. Only its id, and only for this
// page load: a reload already has it in the URL, and a company switch reloads the page
const lastOpen = new Map();

export const rememberConversation = (scope, conversationId) => {
  if (!scope) return;
  if (conversationId) lastOpen.set(scope, conversationId);
  else lastOpen.delete(scope);
};

// Logged out: which chat was last open isn't kept for whoever logs in next
export const forgetLastConversations = () => lastOpen.clear();

export const recallConversation = (scope) => (scope && lastOpen.get(scope)) || null;

// Back in Chat with no chat in the URL: the one last open - only if it's still in my list
// (the server's answer for who can see it). A chat in the URL always wins
export const conversationToRestore = ({ urlChatId, remembered, conversations }) =>
  !urlChatId && remembered && conversations.some((c) => c.id === remembered) ? remembered : null;
